import { Field } from './Field';
import { IMultiField } from './IMultiField';
import { ComparisonType } from './ComparisonType';
import { ListItem } from '../../controls/ListItem';

export class MultiFullTextField extends Field implements IMultiField<ListItem> {
  public values: ListItem[];

  constructor(name: string, description: string, values: ListItem[] = null, comparisonType: ComparisonType = null) {
    super(name, description, MultiFullTextField.typeName(), comparisonType);
    this.values = values;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.MultiFullTextField";
  }
}
